import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import './fonts';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

import { Buffer } from 'buffer';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import routes from './routes';
window.Buffer = Buffer;

if (process.env.REACT_APP_ENVIRONMENT !== 'local') {
  console.log = function () {};
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY,
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENVIRONMENT
  });
  Sentry.setTag('service', 'FE');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const router = createBrowserRouter(routes);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

serviceWorker.unregister();
